import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminPanel from './pages/Admin/AdminPanel';
import CrearTareaPage from './pages/tasks/CrearTareaPage';
import AuthRoutes from './routes/AuthRoutes';
import HomePage from './pages/HomePage';
import SoportePage from './pages/SoportePage';
import TareasCompletarPage from './pages/TareasCompletarPage';
import withAuthAdmin from './routes/withAuthAdmin';
import withAuth from './routes/withAuth';
import VerTareasPage from './pages/tasks/VerTareasPage';
import VerTareasAreaPage from './pages/Admin/VerTareasAreaPage';
import AdministrarUsuariosPage from './pages/Admin/AdministrarUsuariosPage';
import RegisterPage from './pages/Auth/RegisterPage';
import ChangePasswordPage from './pages/Auth/ChangePasswordPage';
import TareasCalificacionPage from './pages/TareasCalificacionPage';

const AdminPanelProtected = withAuthAdmin(AdminPanel);
const HomePageProtected = withAuth(HomePage);
const CrearTareaPageProtected = withAuth(CrearTareaPage);
const VerTareasPageProtected = withAuth(VerTareasPage);
const VerTareasAreaPageProtected = withAuth(VerTareasAreaPage);
const SoportePageProtected = withAuth(SoportePage);
const TareasCompletarPageProtected = withAuth(TareasCompletarPage);
const AdministrarUsuariosSoporteProtected = withAuth(AdministrarUsuariosPage);
const RegisterSoporteProtected = withAuth(RegisterPage);
const ChangePasswordPageProtected = withAuth(ChangePasswordPage);
const TareasCalificacionProtected = withAuth(TareasCalificacionPage);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/home" element={<HomePageProtected />} />
        <Route path="/admin/*" element={<AdminPanelProtected />} />
        <Route path="/crear-tarea" element={<CrearTareaPageProtected />} />
        <Route path="/tareas" element={<VerTareasPageProtected />} />
        <Route path="/soporte" element={<SoportePageProtected />} />
        <Route path="/tareas-completar" element={<TareasCompletarPageProtected />} />
        <Route path="/soporte/ver-tareas-area" element={<VerTareasAreaPageProtected />} />
        <Route path="/soporte/administrar-usuarios" element={<AdministrarUsuariosSoporteProtected />} />
        <Route path="/soporte/crear-usuario" element={<RegisterSoporteProtected />} />
        <Route path="/cambiar-contrasena" element={<ChangePasswordPageProtected />} />
        <Route path="/tareas-calificacion" element={<TareasCalificacionProtected />} />
        <Route path="/auth/*" element={<AuthRoutes />} />
        <Route path="*" element={
          <div className="App">
            <header className="App-header">
              <h1>Tiketeria</h1>
              <p>Bienvenido a la aplicación Tiketeria.</p>
            </header>
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;